// Copyright 2020 The MathWorks, Inc.

require([
  'filebrowser_utils-ui/js/start',
  'dojo/domReady!'
], async (startPromise) => {
  startModule = await startPromise;
  startModule.start();
});